/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Option_New_PlanInputs */

const en_us2_plan_build_option_new_plan = /** @type {(inputs: Plan_Build_Option_New_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask the trainer for a new plan`)
};

const pt_br2_plan_build_option_new_plan = /** @type {(inputs: Plan_Build_Option_New_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedir um plano novo ao personal`)
};

const es_419_plan_build_option_new_plan = /** @type {(inputs: Plan_Build_Option_New_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedirle un plan nuevo al entrenador`)
};

const pt_pt2_plan_build_option_new_plan = /** @type {(inputs: Plan_Build_Option_New_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedir um plano novo ao treinador`)
};

const fr_fr2_plan_build_option_new_plan = /** @type {(inputs: Plan_Build_Option_New_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander un nouveau programme au coach`)
};

const de_de2_plan_build_option_new_plan = /** @type {(inputs: Plan_Build_Option_New_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach um einen neuen Plan bitten`)
};

const it_it2_plan_build_option_new_plan = /** @type {(inputs: Plan_Build_Option_New_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiedi una nuova scheda al coach`)
};

/**
* | output |
* | --- |
* | "Ask the trainer for a new plan" |
*
* @param {Plan_Build_Option_New_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_option_new_plan = /** @type {((inputs?: Plan_Build_Option_New_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Option_New_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_option_new_plan(inputs)
	if (locale === "es-419") return es_419_plan_build_option_new_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_option_new_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_option_new_plan(inputs)
	if (locale === "de-DE") return de_de2_plan_build_option_new_plan(inputs)
	if (locale === "it-IT") return it_it2_plan_build_option_new_plan(inputs)
	return en_us2_plan_build_option_new_plan(inputs)
});
export { plan_build_option_new_plan as "plan-build.option_new_plan" }